import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TextField from '@mui/material/TextField';
import TodayIcon from '@mui/icons-material/Today';
import InputAdornment from '@mui/material/InputAdornment';

// types and classes
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

interface UnconnectedCalendarProps {
  label?: string;
  helperText?: string;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
  views?: $TSFixMe;
  className?: string;
  value?: Date | null;
  onChange?: (value: Date | null) => void;
  error?: boolean;
  errorText?: string;
  disabled?: boolean;
  [key: string]: $TSFixMe;
}

/**
 * UnconnectedCalendar - A calendar component without informed library integration
 * @param label - The label for the calendar input
 * @param minDate - The minimum date. It is inclusive, so the actual date itself can still be selected, just not ones before it
 * @param maxDate - The maximum date
 * @param value - The current value (controlled component)
 * @param onChange - Callback function called with the Date object when the value changes
 */
export const UnconnectedCalendar = (props: UnconnectedCalendarProps) => {
  const {
    label,
    helperText,
    required,
    minDate,
    maxDate,
    views,
    className,
    value,
    onChange,
    error,
    errorText,
    disabled,
    ...rest
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl
        fullWidth={false}
        className={className}
        error={!!error}
        disabled={disabled}
        variant='standard'
        required={required}
      >
        <DatePicker
          {...rest}
          label={label}
          clearable
          value={value ? value : null}
          views={views}
          minDate={minDate}
          maxDate={maxDate}
          desktopModeMediaQuery='(pointer: none), (pointer: fine)'
          onChange={(newValue: Date | null) => {
            onChange && onChange(newValue);
          }}
          InputAdornmentProps={
            <InputAdornment position='end'>
              <TodayIcon color='primary' fontSize='small' />
            </InputAdornment>
          }
          renderInput={(params: $TSFixMe) => (
            <TextField variant='standard' {...params} />
          )}
        />
        {error && errorText ? (
          <FormHelperText>{String(errorText)}</FormHelperText>
        ) : null}
        {helperText && !error ? (
          <FormHelperText>{helperText}</FormHelperText>
        ) : null}
      </FormControl>
    </LocalizationProvider>
  );
};
